import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Day0Banner from '../d0banner/Day0Banner';
import { IState } from '../store/state';
import DomainEvaluationSubpage from './DomainEvaluationSubpage';
import TrainingOverviewPage from './overview/TrainingOverviewPage';
import * as Selectors from './selectors';
import SelfEvaluationView from './self-evaluation/SelfEvaluationView';
import { EvaluationActions } from './slice';
import ExerciseStatistics from './statistics/ExerciseStatistics';
import { IEvaluationPageRouteParams } from './types';
import useUserIdFromRoute from './useUserIdFromRoute';

export const EvaluationRoute = '/evaluation';

export interface IEvaluationProps {
  ready: boolean;
  onOpen: (userId?: number) => void;
}

export const EvaluationPageFC: React.FC<IEvaluationProps> = ({ ready, onOpen }) => {
  const { path } = useRouteMatch<IEvaluationPageRouteParams>();
  const userId = useUserIdFromRoute();
  React.useEffect(() => {
    if (ready) {
      onOpen(userId);
    }
  }, [ready, onOpen, userId]);
  return (
    <>
      <Day0Banner />
      <Switch>
        <Route exact path={`${path}/performance`}>
          <DomainEvaluationSubpage />
        </Route>
        <Route exact path={`${path}/cfq`}>
          <SelfEvaluationView />
        </Route>
        <Route exact path={`${path}/statistics`}>
          <ExerciseStatistics />
        </Route>
        <Route path={`${path}`}>
          <TrainingOverviewPage />
        </Route>
      </Switch>
    </>
  );
};

const mapStateToProps = (state: IState) => {
  const ready = Selectors.isFeatureReady(state);
  return {
    ready,
  };
};

const mapDispatchToProps = {
  onOpen: EvaluationActions.openEvaluation,
};

const Evaluation = connect(mapStateToProps, mapDispatchToProps)(EvaluationPageFC);
export default Evaluation;
